import React, { forwardRef, useEffect, useState, useRef } from 'react'
import grabZone from './img/bx-grid-vertical.svg';
import "./EditWrapper.scss"
import { ButtonBasic } from '@lk-gtcom/ecomlab-components';

const EditWrapper = (({
    id,
    articleId,
    type = 'text',
    child,
    changeBlock = () => { },
    deleteBlock = () => { },
    readonly = false,
    draggableElement,
    setDraggableElement,
    fetchDataById,
    before,
    ind,
    addNewBlock = () => { },
    setIsModalView,
    setContentArr
}) => {

    const [isOver, setIsOver] = useState(false);

    // Возвращаем класс в зависимости от типа блока
    const current_className = () => {
        if (type) return `edit-article-wrapper__${type}`
        return ''
    }

    // Записываем драг элемент
    const onDragStart = (e) => {
        setDraggableElement({
            type: type,
            block_id: id,
        })
        e.dataTransfer.setData("text/plain", e.target.id);
        e.target.style.opacity = "0.3";
    }

    // Вставляем над элементом
    const onDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOver(false); // Убираем цвет при отпускании

        if (draggableElement?.block_id !== before) {
            changeBlock(draggableElement?.type, articleId, draggableElement?.block_id, before)
            setTimeout(() => fetchDataById(articleId), 500)
        }
    }

    return (
        <>
            <div
                id={`edit-wrapper-${id}`} // Уникальный ID
                draggable={!readonly}
                onDragStart={(e) => {
                    if (!readonly) {
                        onDragStart(e);
                    }
                }}
                onDrop={(e) => {
                    if (!readonly) {
                        onDrop(e)
                    }
                }}
                onDragEnd={(e) => {
                    if (!readonly) {
                        e.target.style.opacity = "1"; // Восстанавливаем прозрачность    
                    }
                }}
                onDragOver={(e) => {
                    if (!readonly) {
                        e.preventDefault(); // Нужно для корректной работы дропа
                        setIsOver(true); // Включаем подсветку при наведении 
                    }
                }}
                onDragEnter={(e) => {
                    if (!readonly) {
                        e.stopPropagation(); // Останавливаем всплытие
                        setIsOver(true);
                    }
                }}
                onDragLeave={(e) => {
                    if (!readonly) {
                        e.stopPropagation();
                        setIsOver(false);
                    }
                }}
                className={`edit-article-wrapper ${current_className()}  ${isOver ? "edit-article-wrapper--highlight" : ""}`}>
                {!readonly && <img
                    className='edit-article-wrapper__drag'
                    src={grabZone} />}
                {child}

                {!readonly && <div className="edit-article-wrapper__edit"
                    // Настройка блока
                    onClick={(e) => setIsModalView({ id, type })}
                ></div>}

                {!readonly && <div className="edit-article-wrapper__close"
                    // удаление блока
                    onClick={(e) => {
                        setContentArr((prev) => {
                            return prev.filter((el) => {
                                if (el?.block_id != id) {
                                    return el
                                }
                            })
                        })
                        deleteBlock(id)
                    }}
                ></div>}
            </div >
            {!readonly && <button className='edit-article-wrapper__hover-block'
                onClick={(e) => {
                    addNewBlock(before, ind)
                }}
            >
                + Новый блок
            </button>
            }
        </>
    )
})

export { EditWrapper }